import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';


const HelpDialog = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle 
                sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",                    
                    color: "primary.main",
                    gap: 1,
                }}
            >
                <HelpIcon />                
                <Typography fontWeight="bold">
                    Flight Charts
                </Typography>
            </DialogTitle>

            <DialogContent dividers sx={{ fontSize: "0.95rem" }}>
                <Typography gutterBottom>
                    To ensure the system reads the data correctly, 
                    please export the <strong style={{ color: "#aae86bff" }}>1.2.1. Daily Flight Schedule</strong> from 
                    AIMS following the instructions below:
                </Typography>

                {/* 1. Access AIMS report */}
                <Box mt={2}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "primary.main" }}>
                        1️⃣ Access the Daily Flight Schedule in AIMS
                    </Typography>
                    <Typography>
                        Go to AIMS → 1. Flight Schedule Reports → 2. Reports & Statistics → <strong>1. Daily Flight Schedule</strong><br />
                        Select date range and selection criteria you want to export.
                    </Typography>
                </Box>

                {/* 2. Select Columns */}
                <Box mt={2}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "primary.main"  }}>
                        2️⃣ Select the required columns
                    </Typography>
                    <Typography>
                        In the <strong>Column Selection</strong> panel, please check the following fields:
                    </Typography>

                    <Box
                        mt={1}
                        sx={{
                            border: "1px solid #ccc",
                            borderRadius: 1,
                            padding: 1,
                            fontSize: "0.9rem",
                        }}
                    >
                        Date, A/C Route, Flight Number, Carrier, Flight Service Type, A/C Registration, 
                        A/C, DEP, ARR, STD, STA, ETD, ETA, TKOF, TDWN, ATD, ATA, Block Hours, Flight Hours, 
                        Flight Status, Dep Name, Arr Name, Load Factor %, Taxi out, Taxi in
                    </Box>
                </Box>

                {/* 3. Export instructions */}
                <Box mt={2}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "primary.main"  }}>
                        3️⃣ Export the file in the correct format
                    </Typography>
                    <Typography>
                        The file must be exported from AIMS as a <strong>CSV</strong> file.<br />                        
                    </Typography>
                </Box>

                {/* 4. Upload file */}
                <Box mt={2}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "primary.main"  }}>
                        4️⃣ Upload the file (system processes it in real time and does not store any data)
                    </Typography>
                    <Typography>
                        Click the <strong>Upload daily flight schedule</strong> button → select your CSV file.
                        The system will automatically parse and normalize the CSV data.
                    </Typography>
                </Box>

                {/* 5. Charts */}
                <Box mt={2}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "primary.main"  }}>
                        5️⃣ View charts
                    </Typography>
                    <ul style={{ fontSize: "14px", marginTop: "0px" }}>
                        <li>Switch to chart view based on your selection.</li>
                        <li>Filter data to display charts according to the selected criteria.</li>
                    </ul>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button 
                    variant="outlined" 
                    color="primary"
                    onClick={onClose} 
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default HelpDialog;
